module.exports = __webpack_public_path__ + "img/home_d.faa2fc8a.jpg";